export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M11.527 2.2a.75.75 0 0 1 1.003.05l2.829 2.829a.75.75 0 0 1-1.06 1.06l-1.55-1.548V21.25a.75.75 0 0 1-1.5 0V4.592L9.703 6.14a.75.75 0 1 1-1.06-1.061l2.827-2.828.058-.052Z"/>
</svg>
`;
